import React from 'react';
import { Chip, useT } from '@repo/common';

import { ReactComponent as PlusIcon } from '@repo/common/assets/icons/16px/icon_16px_plus_outline.svg';
import { ReactComponent as CancelIcon } from '@repo/common/assets/icons/16px/icon_16px_cancel.svg';

const SearchSkillsList = ({
  results,
  onToggle,
  keyword,
  selected = [],
  $isMobile,
}) => {
  const t = useT();
  return (
    <div
      className='w-full tabletH:mt-2 bg-grayscale-gray00 tabletH:border tabletH:border-grayscale-gray03 
    rounded-[15px] tabletH:p-6 tabletH:pt-5 z-50 tabletH:shadow-3'
    >
      <div className='typo-b14 tabletH:typo-b14Strong text-text-secondary tabletH:text-text-primary pb-3 tabletH:pb-4'>
        {t('Result :', '검색 결과 :')}
      </div>

      <div className='flex flex-col'>
        {results.length > 0 && (
          <div className='flex flex-wrap gap-2 tabletH:gap-3 pb-3 tabletH:pb-4'>
            {results.map((skill) => {
              const isSelected = selected.includes(skill);

              return (
                <Chip
                  key={skill}
                  onClick={() => onToggle(skill)}
                  iconPosition='after'
                  icon={isSelected ? <CancelIcon /> : <PlusIcon />}
                  state={isSelected ? 'selected' : 'default'}
                >
                  {skill}
                </Chip>
              );
            })}
          </div>
        )}

        <div>
          <Chip
            onClick={() => onToggle(keyword)}
            iconPosition='after'
            disabled={!keyword.trim()}
          >
            {t(
              `Add '${keyword || 'query'}' as a skill`,
              `'${keyword || '검색어'}' 스킬로 추가하기`
            )}
          </Chip>
        </div>
      </div>
    </div>
  );
};

export default SearchSkillsList;
